import React from "react";
import { Link } from "react-router-dom";
import * as Images from "../../Assets/Images";

import {
  Facebook,
  Instagram,
  Twitter,
  Smartphone,
  WhatsApp,
  Mail,
} from "@material-ui/icons";

import "./Footer.css";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageData: [
        {
          pageName: "Privacy Policy",
          pageUrl: "/pages/privacy-policy",
        },
        {
          pageName: "Shipping Policy",
          pageUrl: "/pages/shipping-policy",
        },
        {
          pageName: "Terms and Conditions",
          pageUrl: "/pages/terms-and-conditions",
        },
        {
          pageName: "Payment Options",
          pageUrl: "/pages/payment-options",
        },
        {
          pageName: "Cancellation Policy",
          pageUrl: "/pages/cancellation-policy",
        },
      ],
      siteMap: [
        {
          name: "Home",
          url: "/",
        },
        {
          name: "Catalogue",
          url: "/catalogue",
        },
        {
          name: "About-Us",
          url: "/about-us",
        },
        {
          name: "Contact Us",
          url: "/contact-us",
        },
        {
          name: "Cart",
          url: "/cart",
        },
        {
          name: "Blog",
          url: "/blog",
        },
      ],
    };
  }

  openUrl = (url) => {
    window.open(url);
  };

  render = () => {
    return (
      <div>
        <div className="footer-wrapper">
          <div className="section-1">
            <img
              src={Images.INVOICE_LOGO}
              alt="Brijwasi Logo"
              className="section-1-image"
            />
            <div className="section-1-content">
              Committed to quality and service since 1976, we at Brijwasi Bakery
              are always working relentlessly to provide the best quality bakery
              products and service. What special about us is the extraordinary
              taste and service we give in order to keep you delighted.
            </div>
            {/* <div style={{ marginTop: "10px", textAlign: "center" }}>
            
          </div> */}
          </div>
          {/* <div className="section-2">
          <div className="section-2-heading">Recent from our blogs.</div>
          {DummyData.RECENT_BLOGS.map((item, index) => (
            <div key={index} className="section-2-blogs">
              <div className="section-2-blog-heading">{item.blogHeading}</div>
              <div>{item.blogContent}</div>
            </div>
          ))}
        </div> */}
          <div className="section-1">
            <div className="section-2-heading">Important Links</div>
            {this.state.pageData.map((page, index) => (
              <div key={index} className="pageLinks">
                <Link to={page.pageUrl}>{page.pageName}</Link>
              </div>
            ))}
          </div>
          <div className="section-1">
            <div className="section-2-heading">Site Map</div>
            <div style={{ marginTop: "20px" }}>
              {this.state.siteMap.map((item, index) => (
                <div key={index} className="pageLinks">
                  <Link to={item.url}>{item.name}</Link>
                </div>
              ))}
            </div>
          </div>
          <div className="section-1">
            <div className="section-2-heading">Brijwasi Bakery</div>
            <div className="section-1-bottom">
              <div className="section-1-category">
                <Smartphone style={{ fill: "white", width: "20px" }} />{" "}
                <div className="section-1-cat-heading">+91 8808011133</div>
              </div>
              <div
                className="section-1-category"
                onClick={(e) =>
                  this.openUrl(
                    "https://api.whatsapp.com/send?phone=918808011133&text=Hi+Brijwasi+Bakery&source=&data="
                  )
                }
              >
                <WhatsApp style={{ fill: "white", width: "20px" }} />{" "}
                <div className="section-1-cat-heading">+91 8808011133</div>
              </div>
              <div className="section-1-category">
                <Mail style={{ fill: "white", width: "20px" }} />{" "}
                <div className="section-1-cat-heading">
                  care@brijwasibakery.com
                </div>
              </div>
            </div>
            <div className="section-2-heading">Follow Us</div>
            <div className="section-1-bottom">
              <div
                className="section-1-category"
                onClick={(e) =>
                  this.openUrl("https://www.facebook.com/brijwasibakery")
                }
              >
                <Facebook style={{ fill: "white", width: "20px" }} />{" "}
                <div className="section-1-cat-heading">brijwasibakery</div>
              </div>
              <div
                className="section-1-category"
                onClick={(e) =>
                  this.openUrl("https://www.instagram.com/brijwasibakery/")
                }
              >
                <Instagram style={{ fill: "white", width: "20px" }} />{" "}
                <div className="section-1-cat-heading">brijwasibakery</div>
              </div>
              <div
                className="section-1-category"
                onClick={(e) =>
                  this.openUrl("https://twitter.com/brijwasibakery1")
                }
              >
                <Twitter style={{ fill: "white", width: "20px" }} />{" "}
                <div className="section-1-cat-heading">brijwasibakery1</div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyrightBar">
          {/* &copy;{new Date().getFullYear()} Website Designed and Maintained by
          &copy; <a href="https://www.techbrj.com/" target="_blank"></a>TechBRJ
          &trade;. Mob 7355399530. */}
          &copy;{new Date().getFullYear()} Website Designed and Maintained by
          Brijwasi Bakery Pvt. Ltd.&trade;
        </div>
      </div>
    );
  };
}

export default Footer;
